shadow$provide[366] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `vec4 opaqueColor(vec4 color) {
  return vec4(color.rgb, 1.0);
}
`;

};